import React from 'react';
import { differentiators, photos } from '../data/site';
export function WhyChooseUs() {
  return <section className="bg-parchment py-24" data-id="element-289" data-mp="13xqnjzzonchw">
      <div className="mx-auto grid max-w-[1240px] items-center gap-16 px-6 lg:grid-cols-2" data-id="element-290" data-mp="13wff3mvalgkg">
        <div data-id="element-291" data-mp="q5k4o655arer">
          <p className="eyebrow text-green-dark" data-id="element-292" data-mp="q3ptvknl8foe">Why Premier Advisory</p>
          <h2 className="mt-5 font-display text-[34px] font-medium leading-[1.15] tracking-[-0.01em] text-ink sm:text-[42px]" data-id="element-293" data-mp="u5ulyeye148x">
            Not an ordinary tax and finance advisory firm
          </h2>
          <div className="double-rule mt-7 w-24 text-ink" aria-hidden="true" data-id="element-294" data-mp="l8air0gysxvo" />

          <p className="mt-7 max-w-xl text-[16px] leading-relaxed text-ink-70" data-id="element-295" data-mp="77zrvxfnnjai">
            Clients stay with us because the whole advisory relationship sits in one
            place — the people who audit your books also understand your tax
            position, your payroll and your donor reporting.
          </p>

          <ul className="mt-9 space-y-4" data-id="element-296" data-mp="25m11nsz3hzcw">
            {differentiators.map(item => <li key={item} className="flex items-start gap-3 border-b border-line pb-4" data-id="element-297" data-mp="1ndc6p7oe37x0">
                <span className="mt-0.5 font-mono text-[13px] text-green-dark" aria-hidden="true" data-id="element-298" data-mp="1ieiudiku9myf">
                  ✓
                </span>
                <span className="text-[15px] leading-relaxed text-ink" data-id="element-299" data-mp="1x6jcuuqyery5">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="relative" data-id="element-300" data-mp="14ezluoo489ll">
          <div className="aspect-[4/5] w-full overflow-hidden border border-line" data-id="element-301" data-mp="14g18zrieomjo">
            <img src={photos.reviewing} alt="Advisors discussing a client file in a meeting room" className="h-full w-full object-cover" data-id="element-302" data-mp="zhzor398uh6m" />
          </div>
          <div className="absolute -right-4 -top-8 flex h-32 w-32 flex-col items-center justify-center rounded-full bg-green text-ink sm:-right-8" data-id="element-303" data-mp="19daw30ibom4c">
            <span className="font-display text-[26px] leading-none" data-id="element-304" data-mp="2kuaw6iaww58x">11+</span>
            <span className="mt-1 font-mono text-[9px] uppercase tracking-[0.14em]" data-id="element-305" data-mp="2kwdk8wsi7ob0">Years</span>
            <span className="font-mono text-[9px] uppercase tracking-[0.14em]" data-id="element-306" data-mp="2rzli3nw25ih1">Trusted</span>
          </div>
        </div>
      </div>
    </section>;
}